import { ObjectValues } from 'types';

export const SORTING_ORDER = {
  A_TO_Z: 'a_to_z',
  Z_TO_A: 'z_to_a',
} as const;

export type SortingOrder = ObjectValues<typeof SORTING_ORDER>;

export type SortingField = {
  name: string;
  order: SortingOrder;
};

export type SortByForm = {
  sortBy: SortingField[];
};

export type SortingDirectionValues = Record<
  string,
  Record<SortingOrder, string>
>;

export type SortingDirectionValue = Record<SortingOrder, string>;

export const ASCENDING_DESCENDING_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'ascending',
  [SORTING_ORDER.Z_TO_A]: 'descending',
};

export const INITIAL_ADVANCED_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'initialFirst',
  [SORTING_ORDER.Z_TO_A]: 'advancedFirst',
};

export const EARLIEST_LATEST_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'earliestFirst',
  [SORTING_ORDER.Z_TO_A]: 'latestFirst',
};

export const LOWEST_HIGHEST_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'lowestFirst',
  [SORTING_ORDER.Z_TO_A]: 'highestFirst',
};
